// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'

// format all the modulation data so that it can be sent back to API.
// this formatting is NOT for the modulations details form.
// modulation data for the modulation details form will be prepared
// when the modulation's details are requested by user.
// this we only perform the minimum of data formatting.

const scrubCurveData = rcs => {
  // a curve set is not required for a modulation to be created.
  if (!rcs) {
    return rcs
  }

  rcs.radioCurvePoints.map(d => {
    d.curveTypeCodeId = d.curveTypeCode.curveTypeCodeId
    delete d.curveTypeCode
  })

  return rcs
}

const formatModulation = (m, i) => {
  const {
    bandwidth,
    coChannelTToI,
    dispersiveFm,
    downThreshold,
    emissionDesignator,
    legacyRadioCode,
    maxAtpcTrigger,
    maxRxSignalDbm,
    maxSignatureDepth,
    maxSignatureWidth,
    minAtpcTrigger,
    minDelay,
    minSignatureDepth,
    minSignatureWidth,
    modelNumber,
    modulationDescription,
    modulationScheme,
    nonMinDelay,
    radioModulationId,
    receiverNoiseFigure,
    rxThreshold,
    throughput,
    txPowerMax,
    upThreshold,
    xpif,
  } = m

  const modulationSchemeDescription = makeModulationSchemeLabel(modulationScheme)
  const modulationSchemeId = modulationScheme.modulationSchemeId

  const index = ++i

  const radioCurveSet = scrubCurveData(m.radioCurveSet)

  return {
    bandwidth, // emission bandwidth
    coChannelTToI,
    dispersiveFm, // dispersive fade margin
    downThreshold,
    emissionDesignator,
    index,
    legacyRadioCode,
    maxAtpcTrigger,
    maxRxSignalDbm, // max receive level
    maxSignatureDepth,
    maxSignatureWidth,
    minAtpcTrigger,
    minDelay,
    minSignatureDepth,
    minSignatureWidth,
    modelNumber,
    modulationDescription,
    modulationSchemeDescription, // radio details needs this to display in modulation summary table.
    modulationSchemeId, // maps to "Modulation Scheme" select for modulation details form
    nonMinDelay,
    radioCurveSet,
    radioModulationId, // to track the modulation entity
    receiverNoiseFigure,
    rxThreshold, // threshold
    throughput,
    txPowerMax,
    upThreshold,
    xpif,
    uniqueId: 'radioModulationId',
  }
}

const formatModulationsForRadioDetails = m => (
  m.map((d, i) => formatModulation(d, i))
)

export default formatModulationsForRadioDetails
